export const AUTH_FAILURE = 'AUTH_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const PROFILE_UPDATED = 'PROFILE_UPDATED';
export const CASE_STUDY_CREATED = 'CASE_STUDY_CREATED';
